import { useState, useEffect } from 'react';

export const useCountdown = (startDate: Date, endDate: Date) => {
    const [showCountdown, setShowCountdown] = useState(() => {
        const now = new Date();
        return now >= startDate && now <= endDate;
    });

    useEffect(() => {
        const now = new Date();
        const msUntilStart = startDate.getTime() - now.getTime();
        if (msUntilStart <= 0) return;
        const timer = setTimeout(() => setShowCountdown(true), msUntilStart);
        return () => clearTimeout(timer);
    }, []);

    return [showCountdown, setShowCountdown];
};
